import axios from 'axios';

import Configs from 'root/configs';

let is_refreshing = false;
let queued_requests = [];

export function revokeRefreshToken() {
    let profile_service_client_id_auth_string = Configs.client_id + ':';
    let token = localStorage.getItem('refresh_token');

    if (token == null || typeof token == 'undefined') {
        logoutFromProfileService();
    }

    let post_data = {
        'token': token
    };

    let post_config = {
        headers: {
            'Authorization': 'Basic ' + window.btoa(profile_service_client_id_auth_string)
        }
    };

    axios.post(
        'https://' + Configs.login_host + '/oauth2/revoke',
        post_data,
        post_config
    ).then(() => {
            logoutFromProfileService();
        });
}

export function logoutFromProfileService(msg) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expiry_time');

    let login_branding_id = '';
    if (localStorage.getItem('login_branding_id') !== null) {
        login_branding_id = localStorage.getItem('login_branding_id');
        localStorage.removeItem('login_branding_id');
    }

    const login_branding_param = login_branding_id.length > 0 ? '&b=' + login_branding_id : '';

    let msg_param = '';
    if (msg) {
        msg_param = '&msg=' + msg;
    }

    // Redirect back to login
    window.location = 'https://' + Configs.login_host + '/?client_id=' + Configs.client_id + login_branding_param + msg_param;
}

function subscribeTokenRefresh(callback) {
    queued_requests.push(callback);
}

function onRefreshsed(token) {
    queued_requests.map(callback => callback(token));
}

export function configureHttpClient(config) {
    axios.interceptors.request.use(
        request_config => {
            if (request_config.headers['Auth-Service'] || request_config.headers['Api-Public']) {
                return request_config;
            }

            const access_token = localStorage.getItem('access_token');
            const access_token_expiry_time = localStorage.getItem('expiry_time');
            const refresh_token = localStorage.getItem('refresh_token');

            if (!access_token) {
                if (refresh_token) {
                    revokeRefreshToken();
                }

                logoutFromProfileService();
            }

            let now = Date.now();
            let six_minutes_from_now = now + 360000;
            if (access_token && ((access_token_expiry_time > now && access_token_expiry_time < six_minutes_from_now) || access_token_expiry_time < now)) {
                try {
                    if (!is_refreshing) {
                        is_refreshing = true;

                        // Refresh the token
                        let profile_service_client_id_auth_string = Configs.client_id + ':';
                        let post_data = {
                            grant_type: 'refresh_token',
                            refresh_token: localStorage.getItem('refresh_token')
                        };

                        let post_config = {
                            headers: {
                                'Authorization': 'Basic ' + window.btoa(profile_service_client_id_auth_string),
                                'Auth-Service': 'yes'
                            }
                        };

                        axios.post(
                            'https://' + Configs.login_host + '/oauth2/token', post_data, post_config
                        ).then((response) => {
                                localStorage.setItem('access_token', response.data.access_token);
                                localStorage.setItem('refresh_token', response.data.refresh_token);

                                let expiry_time = Date.now() + (response.data.expires_in * 1000); // Date.now() is measured in milliseconds
                                localStorage.setItem('expiry_time', expiry_time);

                                is_refreshing = false;
                                onRefreshsed(response.data.access_token);
                            }).catch(() => {
                                logoutFromProfileService();
                            });
                    }

                    const retry_or_request = new Promise((resolve, reject) => {
                        subscribeTokenRefresh(token => {
                            // Replace the expired token and retry
                            request_config.headers.Authorization = 'Bearer ' + token;
                            resolve(axios(request_config));
                        })
                    });

                    return retry_or_request;
                } catch (error) {
                    logoutFromProfileService();
                }
            }

            request_config.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token');

            return request_config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            const original_request = error?.config;

            if (error?.response?.status === 401) {
                if (!localStorage.getItem('refresh_token')) {
                    // There's no refresh token so we can't refresh the access token
                    logoutFromProfileService();
                    return Promise.reject(error);
                }

                if (!is_refreshing) {
                    is_refreshing = true;

                    // Refresh the token
                    let profile_service_client_id_auth_string = Configs.client_id + ':';
                    let post_data = {
                        grant_type: 'refresh_token',
                        refresh_token: localStorage.getItem('refresh_token')
                    };

                    let post_config = {
                        headers: {
                            'Authorization': 'Basic ' + window.btoa(profile_service_client_id_auth_string),
                            'Auth-Service': 'yes'
                        }
                    };

                    axios.post(
                        'https://' + Configs.login_host + '/oauth2/token', post_data, post_config
                    ).then((response) => {
                            localStorage.setItem('access_token', response.data.access_token);
                            localStorage.setItem('refresh_token', response.data.refresh_token);

                            let expiry_time = Date.now() + (response.data.expires_in * 1000); // Date.now() is measured in milliseconds
                            localStorage.setItem('expiry_time', expiry_time);

                            is_refreshing = false;
                            onRefreshsed(response.data.access_token);
                        }).catch(() => {
                            logoutFromProfileService();
                        });
                }

                const retry_or_request = new Promise((resolve, reject) => {
                    subscribeTokenRefresh(token => {
                        // Replace the expired token and retry
                        original_request.headers.Authorization = 'Bearer ' + token;
                        resolve(axios(original_request));
                    })
                });

                return retry_or_request;
            } else {
                return Promise.reject(error);
            }
        }
    );
}

export default axios;